import { Tab, } from '@mui/material';
import { a11yProps, useTabsFormOnly } from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  NestedTabsScene,
} from '@/shared/components/ui';
import { Contrato } from '@/shared/interfaces';
import ClienteFibraRubroTab from './ClienteFibraRubroTab';
import ClienteFibraSaldoTab from './ClienteFibraSaldoTab';
import ClienteFibraTransaccionTab from './ClienteFibraTransaccionTab';

export type ClienteFibraRubrosFormTabProps = {
  contract: Contrato;
};

const ClienteFibraRubrosFormTab: React.FC<ClienteFibraRubrosFormTabProps> = ({
  contract,
}) => {
  ///* hooks -------------------------
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });


  return (
    <NestedTabsScene
      tabs={
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Rubros" value={1} {...a11yProps(1)} />
          <Tab label="Transacciones" value={2} {...a11yProps(2)} />
          <Tab label="Saldos" value={3} {...a11yProps(3)} />
        </FormTabsOnly>
      }
    >
      <CustomTabPanel index={valueTab} value={1}>
        <ClienteFibraRubroTab contract={contract} />
      </CustomTabPanel>

      <CustomTabPanel index={valueTab} value={2}>
        <ClienteFibraTransaccionTab contract={contract} />
      </CustomTabPanel>

      <CustomTabPanel index={valueTab} value={3}>
        <ClienteFibraSaldoTab contract={contract} />
      </CustomTabPanel>
    </NestedTabsScene>
  );
};

export default ClienteFibraRubrosFormTab;
